import api from '../services/api';

export const productsAPI = {
  getAll: (params) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  duplicate: (id) => api.post(`/products/${id}/duplicate`),
  getInventory: (id) => api.get(`/products/${id}/inventory`),
  createAssetUpload: (id, data) => api.post(`/products/${id}/assets/presign`, data),
  attachAsset: (id, data) => api.post(`/products/${id}/assets`, data),
  getAssetAccess: (id, key) => api.get(`/products/${id}/assets/access`, { params: { key } }),
  adjustInventory: (id, data) => api.put(`/products/${id}/inventory`, data),
  transferInventory: (id, data) => api.post(`/products/${id}/inventory/transfer`, data),
  exportProducts: (format = 'csv') => api.get(`/products/export?format=${format}`),
  getLowStock: () => api.get('/products/alerts/low-stock'),
  getReorderAlerts: () => api.get('/products/alerts/reorder'),

  // Dashboard KPIs
  getInventoryValue: () => api.get('/products/stats/inventory-value'),
  getStockoutForecast: (params) => api.get('/products/stats/stockout-forecast', { params }),
};

export default productsAPI;
